import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Proovi värskendada

  <span style="color:#85c1dc;">**FI:**</span>
  Yritä päivittää

  <span style="color:#85c1dc;">**RU:**</span>
  Попробуйте обновить
*/
/* @__NO_SIDE_EFFECTS__ */
const m660 = msg(
  mf`Proovi värskendada`,
  mf`Yritä päivittää`,
  mf`Попробуйте обновить`,
)

export { m660 as 'site-error.button.refresh' }